import React from 'react';
import { useLocation } from 'react-router';
import { Switch, Route, Redirect } from 'react-router-dom';
import { TransitionGroup, CSSTransition } from 'react-transition-group';

import Navbar from 'components/NavBar';
import SuperInfo from 'components/SuperInfo';
import Pages from 'pages';
import NotAllowed from 'pages/NotAllowed';

import PrivateRoute from './Private';
import Login from './Login';
import Callback from './Callback';

export default function Routes() {
  const location = useLocation();
  return (
    <TransitionGroup>
      <Route path="*">
        <Switch location={location}>
          <Route exact path="/" render={() => <Redirect to="/Login" />} />
          <Route exact path="/not-allowed" component={NotAllowed} />
          <Route exact path="/Login" component={Login} />
          <Route exact path="/Callback" component={Callback} />
        </Switch>
      </Route>
      <Route path="/auth">
        <SuperInfo />
        <Navbar />
        <CSSTransition classNames="fade" key={location.key} timeout={500}>
          <Switch location={location}>
            {Pages.map(page => (
              <PrivateRoute
                key={page.route}
                exact={page.isExact}
                path={page.route}
                component={page.page}
                accessId={page.permissionId}
              />
            ))}
          </Switch>
        </CSSTransition>
      </Route>
    </TransitionGroup>
  );
}
